import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useUser} from "../../allauth/auth";
import SplashScreen from "./SplashScreen";

export default function Landing() {

    const location = useLocation();
    const me = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname === '/') {
            if (me) {
                navigate('/select-campaign');
            } else {
                navigate('/login');
            }
        }
    }, [me, location])

    return <SplashScreen />
}
